<template>
  <div>
    <Loader />
    <navbar />

    <section class="base-section" style="min-height: 800px">
      <div class="container">
        <slot/>
      </div>
    </section>

    <foot />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Foot from '@/components/Foot'
import Loader from '@/components/Loader'

export default {
  name: 'LayoutBasic',

  components: {
    Navbar,
    Foot,
    Loader
  }
}
</script>
